import React from "react";
import styles from "./insurance-comp.module.scss";
import magGlass from "../../../src/assets/magnifying_glass.svg"

const PopUp = ({
  options,
  click,
  title,
  searchable,
}: {
  options: string[];
  click: (selection: string) => void;
  title?: string;
  searchable?: boolean;
}) => {
  const [search, setSearch] = React.useState("");

  const filtered = search.trim()
    ? options.filter((o) => o.toLowerCase().includes(search.toLowerCase()))
    : options;

  return (
    <div className={styles["out-contain"]}>
      <div className={styles.contain}>
        <div className={styles["sel-contain"]}>
          <span>{title ? title : "SELECT"}</span>
        </div>

        {searchable && (
          <div className={styles["s-contain"]}>
            <img src={magGlass} alt="" />
            {/* <span className={styles["s-icon"]}>🔍</span> */}
            <input
              className={styles["s-inp"]}
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        )}

        {filtered.map((option) => (
          <div
            key={option}
            className={styles["item-contain"]}
            role="button"
            onClick={() => click(option)}
          >
            <span>{option}</span>
          </div>
        ))}

        {filtered.length === 0 && (
          <div className={styles["no-results"]}>
            <span>No results found</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PopUp;
